import React from 'react';
import {
  RSVPDeclined,
  Spacer,
} from '@resy/ui-kitchen';

import './Declined.scss';

const Declined = () => (
  <>
    <RSVPDeclined />
    <Spacer height="60" />
  </>
);

export default Declined;
